import { Injectable } from '@angular/core';
import { IMarkerData } from '@core/interface';
import { MAP_CONFIG } from '@core/utils';

/**
 * Service responsável pela lógica de manipulação de marcadores
 * Centraliza operações relacionadas a cálculos e gerenciamento de marcadores
 */
@Injectable({
  providedIn: 'root'
})
export class GoogleMapMarkersService {

  /**
   * Calcula o centro geográfico baseado em uma lista de marcadores
   */
  calculateCenter(markers: IMarkerData[]): { lat: number; lng: number } {
    if (markers.length === 0 || !markers[0].position) return MAP_CONFIG.DEFAULT_CENTER;

    const totalLat = markers.reduce((sum, marker) => sum + marker.position.lat, 0);
    const totalLng = markers.reduce((sum, marker) => sum + marker.position.lng, 0);
    return {
      lat: totalLat / markers.length,
      lng: totalLng / markers.length
    };
  }

  /**
   * Calcula o nível de zoom adequado baseado na dispersão dos marcadores
   */
  calculateZoom(markers: IMarkerData[]): number {
    if (markers.length <= 1) return MAP_CONFIG.DEFAULT_ZOOM;

    // Calcula zoom baseado na distância entre os pontos
    const lats = markers.map(m => m.position.lat);
    const lngs = markers.map(m => m.position.lng);

    const latSpan = Math.max(...lats) - Math.min(...lats);
    const lngSpan = Math.max(...lngs) - Math.min(...lngs);
    const maxSpan = Math.max(latSpan, lngSpan);

    // Define zoom baseado na dispersão dos marcadores
    if (maxSpan > 1) return 8;    // Muito disperso - zoom baixo
    if (maxSpan > 0.1) return 10; // Médio disperso
    if (maxSpan > 0.01) return 15; // Pouco disperso
    return 17; // Muito próximos - zoom alto
  }

  /**
   * Atualiza título do marcador com base no endereço
   */
  updateMarkerWithAddress(marker: IMarkerData, address: string): void {
    if (marker.id === MAP_CONFIG.MARKER_IDS.CLICKED) {
      marker.address = address;
      marker.title = `${MAP_CONFIG.MARKER_TITLES.CLICKED} - ${address.split(',')[0]}`;
    }
  }

}
